export const deviceStatusPageSize = 20;
export const deviceStatusPageSizeOptions = [20, 50, 100];
export const startDateLimit = 89;
export const commonHeaders = {
    // serialNumber: "S.No",
    ts: {header:"Timestamp",desc:""},
};

export const deviceStatusTableConfig = {
    storageType: "local",
    sessionStorageKey: "deviceStatus.visibleColumns",
    defaultVisibleColumns: ["createdAt", "ps", "actions"],
    lockedColumns: ["actions"],
    columnSequence: ["createdAt", "ps", "actions"],
    defaultSort: { key: "createdAt", order: "desc" },
    keyAliases: {
        // Prefer createdAt label while hydrating from payloads that still list `ts`.
        createdAt: ["createdAt", "ts"],
    },
    columns: {
        createdAt: { label: "Created At", sortable: true, filterable: true, filterType: "text", minWidth: 220 },
        ps: { label: "Power State", sortable: true, filterable: true, filterType: "text", minWidth: 150 },
        actmp: { label: "AC Temp", sortable: true, filterable: true, filterType: "text", minWidth: 150 },
        acmd: { label: "AC Mode", sortable: true, filterable: true, filterType: "text", minWidth: 150 },
        actions: {
            label: "Actions",
            sortable: false,
            filterable: false,
            minWidth: 110,
            align: "center",
            justifyContent: "center",
            // Sticky rail: row details action stays visible when grid scrolls horizontally.
            headerCellSx: { position: "sticky", right: 0, zIndex: 3 },
            cellSx: { position: "sticky", right: 0, zIndex: 2, backgroundColor: "background.paper" }
        },
    },
};